// import components
import { Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ControlledAutoComplete } from 'components/shared';
import { GridContainer } from 'components/shared/Grid/Grid.components';

// import hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// import utils
import { useGetPoolOptions } from './utils/useGetPoolOptions';

export const PoolDropdown = ({
  name
}: {
  name: 'employeePool' | 'requestPool';
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { isFetching, data } = useGetPoolOptions();

  return (
    <>
      {isFetching ? (
        <>
          <Skeleton />
        </>
      ) : (
        <GridContainer>
          <Grid sx={{ width: '100%' }}>
            <ControlledAutoComplete
              fullWidth
              idProperty="value"
              optionLabelProp="label"
              variant="outlined"
              label={t(name)}
              name={name}
              options={data}
              control={control}
            />
          </Grid>
        </GridContainer>
      )}
    </>
  );
};
